import React, { useMemo } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { withList } from "../../../../../../components/list";
import moment from "moment";

const PointsItem = props =>{
    const { point, isExpired } = props;

    const createTime = useMemo(() =>{
        if(point?.createTime){
            return moment(point.createTime).format('MMM.DD.YYYY HH:mm:ss')
        }
    }, [point]);

    const expiredDate = useMemo(() =>{
        if(point?.expiredDate){
            return moment(point.expiredDate).format('MM/DD/YYYY HH:mm:ss')
        }
    }, [point]);

    const pointNumber = useMemo(() =>{
        return point?.points > 0 ? `+${point.points}` : point.points;
    }, [point]);

    return <div className={cls.PointsItem}>
        <div className={cls.Container}>
            <div className={cls.Left}>{createTime}</div>

            <div className={cls.Center}>
                <div className={cls.Font1}>{point?.name}</div>
                {
                    expiredDate && <div className={cls.Font2}>Expiration:{expiredDate}</div>
                }
            </div>

            <div className={cls.Right}>
                <span className={`${cls.ElPoint} ${point?.points < 0 || isExpired ? cls.ElPointPlus : ""}`}>{pointNumber}</span>
            </div>
        </div>
    </div>
}

const PointsHistoryList = props =>{
    useStyles(cls);
    const { list } = props;

    return <div className={cls.PointsHistoryList}>
        {
            list?.map((point, index) =>(
                <PointsItem key={index} point={point} {...props} />
            ))
        }
    </div>
}

export default withList(PointsHistoryList);

